import { ContainerModule, interfaces } from "inversify";
import { IocTypes } from "../ioc.types";
import IInvoiceService from 'features/invoices/services/IInvoiceService';
import InvoiceService from 'features/invoices/services/InvoiceService';

export const invoicesModule = new ContainerModule((bind: interfaces.Bind) => {
  bind<IInvoiceService>(IocTypes.InvoiceService).to(InvoiceService);
});